/**
 * Labstep
 *
 * @module screens/PurchaseOrder/Index/LeftPane
 * @desc PurchaseOrder Index LeftPane
 */

import { LayoutLeftPane } from 'labstep-web/components/Layout/LeftPane';
import { PurchaseOrderFilterPane } from 'labstep-web/components/PurchaseOrder/Filter/Pane';
import type React from 'react';
import type { IPurchaseOrderIndexLeftPaneProps } from './types';

export const PurchaseOrderIndexLeftPane: React.FC<
  IPurchaseOrderIndexLeftPaneProps
> = ({ links }) => (
  <LayoutLeftPane links={links}>
    <PurchaseOrderFilterPane />
  </LayoutLeftPane>
);
